import * as o from "react";
import s from "../lib/IconBase.es.js";
import a from "../defs/Quotes.es.js";
const e = o.forwardRef((t, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...t, weights: a }));
e.displayName = "QuotesIcon";
const n = e;
export {
  n as Quotes,
  e as QuotesIcon
};
